import React, { useState } from 'react';
import { Select, Checkbox, Divider, Icon  } from 'antd';

import CustomBtn from '../buttons/CustomBtn';

const { Option } = Select;

const diasSemana = ['LUNES', 'MARTES', 'MIERCOLES', 'JUEVES', 'VIERNES', 'SABADO', 'DOMINGO'];

const ClassroomFilters = ({ teachers = [], onFilterChange }) => {
  const [selectedDays, setSelectedDays] = useState([]);
  const [selectedTeachers, setSelectedTeachers] = useState([]);
  const [collapsed, setCollapsed] = useState(true);

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };


  const handleApplyFilters = () => {
    onFilterChange({
      dias: selectedDays,
      maestros: selectedTeachers,
    });
  };

  const handleClear = () => {
    setSelectedDays([]);
    setSelectedTeachers([]);
    onFilterChange({ dias: [], maestros: [] });
  };

   return (
   <div  style={{ width: '100%', marginBottom:20, marginRight:20}}>
      <div style={{ display: 'flex', alignItems: 'center', width: '100%', cursor: 'pointer' }} onClick={toggleCollapse}>
        <Divider orientation="left" style={{ flex: 1, margin: 0}}>
          Filtros
        </Divider>
        <Icon
          type={collapsed ? 'caret-down' : 'caret-up'}
          style={{ marginLeft: 5, marginRight: 12, fontSize: 23, cursor: 'pointer' }}
          onClick={toggleCollapse}
        />
      </div>


      {!collapsed && (
        <div style={{ marginBottom: 16 }}>
          <div style={{ marginBottom: 8 }}>
            <span>Días: </span><br/>
            <Checkbox.Group
              options={diasSemana}
              value={selectedDays}
              onChange={setSelectedDays}
            />
          </div>

          <div style={{ marginBottom: 8 }}>
            <span>Maestros: </span>
            <Select
              mode="multiple"
              style={{ width: '100%' }}
              placeholder="Selecciona maestros"
              value={selectedTeachers}
              onChange={setSelectedTeachers}
            >
              {(Array.isArray(teachers) ? teachers : []).map(teacher => (
                <Option key={teacher.idUsuario} value={teacher.idUsuario}>
                  {teacher.nombre + teacher.apellido}
                </Option>
              ))}
            </Select>
          </div>

          <div style={{ display: 'flex', gap: 60, marginTop: 25, paddingLeft:60, paddingRight:60 }}>
            <CustomBtn
                text={'Aplicar Filtros'}
                onClick={handleApplyFilters}
            />
            <CustomBtn
                text='Limpiar'
                onClick={handleClear}
                color='white'
                textColor='black'
                borderColor='black'
            />
          </div>
      </div>
     
       )}

</div>
    
  );

};

export default ClassroomFilters;
